/**
 * PlacementOverlay component
 * Shows "Tap to place" visual indicator during AR placement mode
 */
interface PlacementOverlayProps {
  /**
   * Optional custom message (default: "Tap to Place")
   */
  message?: string;
}

export function PlacementOverlay({ message = "Tap to Place" }: PlacementOverlayProps) {
  return (
    <div 
      className="fixed z-[20] inset-0 w-full h-full flex items-end justify-center"
      style={{ 
        pointerEvents: "none",
        paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 40px)",
      }}
    >
      {/* Rounded transparent black container */}
      <div 
        className="bg-black/65 rounded-2xl py-8"
        style={{ 
          boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.25)",
          width: "400px",
          maxWidth: "calc(100vw - 32px)",
        }}
      >
        <p 
          className="text-white text-center font-extrabold text-[30px] tracking-wide"
          style={{ fontFamily: "'Roboto', 'Poppins', sans-serif" }}
        >
          {message}
        </p>
      </div>
    </div>
  );
}
